import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import React, { useCallback } from 'react';
import { IconXMarkSmall } from '@byted-tiktok/tux-icons';
import { useControlled } from '../../hooks/useControlled.js';
import { TUXSheetWIP } from '../TUXSheet/TUXSheet.js';
import { TUXTableRadioCell } from '../TUXTableCell/TUXTableRadioCell.js';
import { TUXTitleBar } from '../TUXTitleBar/TUXTitleBar.js';

var _ref2 = /*#__PURE__*/React.createElement(IconXMarkSmall, null);

var TUXSingleSelectSheetWIP = function TUXSingleSelectSheetWIP(_ref) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
      title = _ref.title,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      onDismiss = _ref.onDismiss,
      onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      getContainer = _ref.getContainer;

  var _useControlled = useControlled({
    value: value,
    defaultValue: defaultValue
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      internalValue = _useControlled2[0],
      setInternalValue = _useControlled2[1];

  var handleClickItem = useCallback(function (val) {
    setInternalValue(val);
    val !== internalValue && (onChange === null || onChange === void 0 ? void 0 : onChange(val));
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(val);
  }, [internalValue, onChange, onSubmit, setInternalValue]);
  return /*#__PURE__*/React.createElement(TUXSheetWIP, {
    getContainer: getContainer,
    isVisible: isVisible,
    onDismiss: onDismiss,
    header: /*#__PURE__*/React.createElement(TUXTitleBar, {
      showSeparator: true,
      title: title,
      endActions: {
        actionVariant: 'icon',
        icon: _ref2,
        onClick: onDismiss
      }
    }),
    minHeight: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-8"
  }, _mapInstanceProperty(options).call(options, function (v, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      onClick: function onClick(e) {
        e.preventDefault();
        handleClickItem(v.value);
      }
    }, /*#__PURE__*/React.createElement(TUXTableRadioCell, {
      title: v.title,
      subTitle: v.subTitle,
      value: v.value,
      checked: internalValue === v.value
    }));
  })));
};

export default TUXSingleSelectSheetWIP;
export { TUXSingleSelectSheetWIP };
//# sourceMappingURL=TUXSingleSelectSheet.js.map
